var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v480h640V0H0z",
    fillRule: "evenodd",
    fill: "#67b1ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#0000b4",
    d: "M0 0h431.43v277.167H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v30.99l383.195 246.18h48.234v-30.988L48.233 0H0zm431.43 0v30.988L48.233 277.17H0v-30.987L383.195 0h48.234z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.762 0v277.17h71.905V0h-71.905zM0 92.39v92.39h431.43V92.39H0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 110.87v55.433h431.43V110.87H0zM194.143 0v277.17h43.143V0h-43.143zM0 277.17l143.81-92.39h32.155l-143.81 92.39H0zM0 0l143.81 92.39h-32.156L0 20.66V0zm255.463 92.39L399.273 0h32.156L287.62 92.39h-32.157zM431.43 277.17l-143.81-92.39h32.155l111.654 71.733v20.658z",
    fill: "#c00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.43 137.047V296.31c20.534 111.483 56.467 127.41 102.667 159.262 46.2-31.853 82.132-47.78 102.666-159.263V137.046H391.43z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.408 137.047l.215 309.49 13.69 8.987L508 446.288l-.214-309.236h-27.378z",
    fill: "#da0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.43 297.99l10.27 43.38 185.335-.12 9.73-43.26H391.433zm0-160.943h205.333V248.53H391.43z",
    fill: "#da0000"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.28 0 0 .4 309.75 297.89)"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 23.225,
    ry: 27.989,
    height: 55.978,
    width: 46.45,
    stroke: "#000",
    y: -281.68,
    x: 306.09,
    strokeWidth: 0.75,
    fill: "#f6efec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.4-296.57s47.64-3.573 64.315-22.63c16.675-19.056-11.314-53.596 6.55-57.17 7.147-.595 17.27 1.788 25.012 11.315-1.19-7.145-5.955-11.314-7.74-15.48-6.552-5.958-13.103-5.362-22.63-5.362-6.552 1.192-7.743-1.192-18.46-13.697-5.36-5.955-5.36-20.842-1.193-30.966-12.505 9.528-10.123 22.628-8.932 25.606 2.977 13.102 5.955 16.675 5.955 22.63-3.573-1.786-10.124-17.27-44.068-19.652-33.946-2.382-119.7 23.82-158.41 23.82-38.71 0-94.688-16.078-94.688-16.078s14.292-11.315-2.978-16.08c-17.27-4.763-55.382 16.676-66.102 4.765-7.74-11.314-4.764-8.932-5.955-14.29-2.977 1.785-4.764 8.932-.595 18.46 4.168 9.528 6.55 6.55 5.955 6.55-.596 0-13.697 0-14.888 4.765-1.192 3.572-2.98 7.74 3.572 20.842 2.382-13.1-6.55-14.887 13.1-16.078 19.654-1.192 33.35 7.74 50.024 10.718 16.675 2.978 16.675-7.146 17.27-6.55.596.595 51.214 14.292 97.664 11.314 46.45-2.977 121.49-28.585 156.02-23.225 34.54 5.36 57.17 30.37 57.765 53.596-.595 14.292-15.483 21.438-27.393 23.82-14.292 2.382-47.64 5.956-47.64 5.956l18.46 13.1z",
    transform: "matrix(.88 0 0 .7 113.77 -89.63)",
    stroke: "#000",
    strokeWidth: 0.875,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.06-248.92c-.596 0-32.754.596-42.282 14.292-9.528 13.697-13.697 26.8-13.1 26.8.594 0 21.437-11.316 21.437-11.316s-15.483 22.63-7.146 42.877c8.336 20.247-22.01 19.056-39.508 19.65-7.742-5.954-32.473-16.078-41.292-17.864-5.507-2.085-16.32-2.354-27.616 10.346-6.653 7.83 9.888-7.37 26.295-6.178 1.773 1.786 2.915 3.574 3.23 7.74-8.74-.594-17.84-10.718-28.558 10.125 10.72-7.146 12.06-6.997 17.493-7.444 7.24-.537 6.31 3.275 6.01 3.275-1.19 0-4.144.595-8.616 4.764-2.383 2.976-8.338 9.527-7.147 9.527s4.752-3.573 10.327-6.55c3.484-2.383 6.793-2.383 17.322.595 57.765 13.696 88.73 3.573 92.304-1.787 1.787-2.38-33.35-69.675 60.147-87.54-1.19-.596-39.303-10.72-39.303-11.315z",
    transform: "matrix(.85 0 0 1 231.25 -38.11)",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.84-212.6c32.753 27.394 253.69-29.18 281.68-48.832 16.08-11.315 44.068-19.652 44.068 19.056 7.146-26.203 7.147-32.753 7.147-32.158.595.596 11.314 10.125 20.843 42.283 2.382-28.587-4.17-45.26-.596-42.88 2.382-2.38 2.382 14.293 21.438 37.518-4.168-18.46-5.36-26.798-5.36-26.798s35.732 34.54 55.98 39.304c20.247 4.764 49.427-9.528 58.36-1.19 8.932 8.337 24.418 23.224 23.818 35.135-.59 11.91-33.347 1.785-36.92 11.313-3.573 9.53 2.382 9.53 2.382 9.53s2.977 7.145 5.36 13.1c1.786-4.17-1.787-13.102 4.764-13.697 4.764.595 4.764 8.337 5.955 12.506 1.388-4.764-.2-14.292 4.168-14.292 4.764-.993 5.36 7.543 8.932 13.1v-13.1c13.698-4.17 25.604-4.764 27.394-13.697 1.78-8.933-20.846-29.18-26.206-42.282-5.356-13.1 4.17-18.46-5.952-25.606-10.123-7.146-48.832 11.315-66.697 4.17-17.867-7.147-10.72-58.362-78.014-69.676-67.293-11.315-249.52 59.55-281.68 62.53-32.158 2.976-71.46-10.125-71.46-10.125l.594 54.787z",
    stroke: "#000",
    strokeWidth: 0.625,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.43-263.22s-28.585-37.518-51.81-41.09c-23.225-2.978-45.855 14.292-50.62 11.91-4.763-2.383-6.55.596-9.527 5.955-2.978 5.36.596 8.932.595 8.337 1.19 0 4.17-8.933 5.36-9.528 1.192-.596-5.955 10.72 1.192 11.91 2.382.596 3.573-8.337 6.55-11.91.596.595-4.764 12.506-1.786 13.1 2.977.597 6.55-11.91 11.91-14.887 7.742-5.36 19.056-7.147 33.35-7.146 14.29 4.17 43.47 38.71 46.45 38.113l8.336-4.763z",
    transform: "matrix(.98 .23 .18 -1.25 64.17 -655.73)",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.43-263.22s-28.585-37.518-51.81-41.09c-23.225-2.978-45.855 14.292-50.62 11.91-4.763-2.383-6.55.596-9.527 5.955-2.978 5.36.596 8.932.595 8.337 1.19 0 4.17-8.933 5.36-9.528 1.192-.596-5.955 10.72 1.192 11.91 2.382.596 3.573-8.337 6.55-11.91.596.595-4.764 12.506-1.786 13.1 2.977.597 6.55-11.91 11.91-14.887 7.742-5.36 19.056-7.147 33.35-7.146 14.29 4.17 43.47 38.71 46.45 38.113l8.336-4.763z",
    transform: "matrix(1 0 0 1.13 11.31 42.24)",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.46-267.98l-31.562 15.483 23.225 5.956-16.675 19.056 23.82-7.742-1.785 25.607 13.697-16.673 8.932 23.225 9.528-17.27 11.315 19.056 4.764-18.46 13.696 18.46 4.764-25.01 16.675 15.482-2.382-26.203 20.247 6.55-12.506-20.247s22.034-1.19 20.843-1.19-16.674-13.102-30.37-16.675l-76.227.595z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.46-267.98l-31.562 15.483 23.225 5.956-16.675 19.056 23.82-7.742-1.785 25.607 13.697-16.673 8.932 23.225 9.528-17.27 11.315 19.056 4.764-18.46 13.696 18.46 4.764-25.01 16.675 15.482-2.382-26.203 20.247 6.55-12.506-20.247s22.034-1.19 20.843-1.19-16.674-13.102-30.37-16.675l-76.227.595z",
    transform: "matrix(.55 0 0 .57 205.56 -123.01)",
    stroke: "#000",
    strokeWidth: 0.808,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.06-316.81s-8.93-7.146-12.504 0c-3.574 7.147 7.74 4.17 7.74 5.36s-7.74 9.528-7.74 19.057c0 9.528 5.955 25.607 5.955 27.99s2.383 8.93 10.72 11.313 11.315-7.74 13.1-8.932c1.788-1.19 13.103 1.786 17.27-8.337 4.17-10.123 4.17-28.584 4.17-28.584s7.146 5.36 7.146-5.36-7.742 0-7.742 0 1.19-11.314-17.27-16.674-20.247 5.36-20.843 4.168z",
    stroke: "#000",
    strokeWidth: 0.5,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.48-317.31c-2.38-4.827-9.14-23.32-9.14-23.32l16.205 6.942c-5.53-1.374-10.25-2.18-9.654-2.18.596 0 7.147 8.934 7.147 8.934 6.45-.374 12.903 1.774 20.843 3.503 0 0 6.55-7.287 5.955-7.287-.596 0-3.573-1.192-3.573-1.192l14.888-6.83-4.764 9.214h-2.978l-5.955 6.69c6.7 1.26 9.975 2.242 16.525 6.445 5.807-.84 10.72-3.852 13.846-6.13-5.21-1.437-7.592-2.558-6.997-2.558.596 0 21.885 1.12 21.885 1.12s-20.89 12.917-33.093 17.65c-11.29-3.245-39.95-9.215-41.14-11.002z",
    transform: "matrix(.94 -.02 .03 1.42 35.5 137.73)",
    stroke: "#000",
    strokeWidth: 0.54,
    fill: "#ff0"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9 .43 -1 -.1 0 0)",
    rx: 6.865,
    ry: 3.077,
    height: 6.153,
    width: 13.731,
    y: -1416.1,
    x: -1065.8
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.9 .43 -1 -.1 0 0)",
    rx: 6.865,
    ry: 3.077,
    height: 6.153,
    width: 13.731,
    y: -1419.6,
    x: -1050
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.95 .32 -1 -.08 0 0)",
    rx: 12.761,
    ry: 5.97,
    height: 11.94,
    width: 25.522,
    y: -1636.5,
    x: -1253.9
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.94 .35 -1 -.1 0 0)",
    rx: 5.781,
    ry: 2.674,
    height: 5.349,
    width: 11.562,
    y: -1565.8,
    x: -1186.4
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.33 -.94 .14 1 0 0)",
    rx: 4.931,
    ry: 2.046,
    height: 4.093,
    width: 9.861,
    y: 734.39,
    x: 1061.7
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "matrix(1.1 0 0 1.27 -361.45 -17.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M737.05 319.5c1.663 4.742.814 0-.957 7.344 1.094-2.188 2.656-3.438 3.28-3.437.94 0 1.407 0 3.282 1.406-1.718-2.5-4.687-1.875-4.53-5.625-.157-.86-1 .08-1.075.312z",
    transform: "matrix(1.05 0 0 1.4 -30.43 -120.97)",
    strokeWidth: 0.375,
    fill: "#ff7300"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.82 -.57 .2 .98 0 0)",
    rx: 0.685,
    ry: 0.506,
    height: 18.038,
    width: 1.369,
    y: 717.59,
    x: 708.8,
    strokeWidth: 0.103,
    fill: "#b2802e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.06 312.16c.78-.47 6.562-11.094 34.062-9.532-15.625 5.313-25.313 16.563-27.656 17.03-1.72.47-5.47-5.78-6.406-7.498z",
    transform: "matrix(.8 0 0 .98 152.8 3.9)",
    strokeWidth: 0.375,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.333,
    fill: "#007500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l-7.42-2.76 15.13 11.39-2.9-5.35-4.81-3.28z",
    transform: "matrix(-.5 -1.05 .3 .95 159.9 514.87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l-5.31.27 12.7 7.59-2.58-4.58-4.81-3.28z",
    transform: "matrix(.07 -.68 -.3 .54 -293.62 91.01)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.9-4447.6l4.64 7.4 4.42 1.26-3.58-4.96-5.48-3.7z",
    transform: "matrix(-1.36 -.47 1.52 .64 2287.67 1355.68)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3821.8-4448.7l17.53 22.4-6.67-12.48-3.47-5.09-7.39-4.83z",
    transform: "matrix(-.55 .32 .76 -.15 2024.7 827.17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3822.2-4449.9l-12.5-6.51 24.05 18.66-3.81-6.13-7.74-6.02z",
    transform: "matrix(.98 .07 -1.18 -.24 -766.75 -528.55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3823.5-4450.2l-5.23-1.22 17.81 13.32-3.56-5.79-9.02-6.31z",
    transform: "matrix(1.5 .65 -1.64 -.82 -831.78 -851.13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3824.7-4451.7l-13.4-9.74 24.35 20.96-.74-3.33-10.21-7.89z",
    transform: "matrix(1.75 1.24 -1.77 -1.34 -460.51 -944.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3822.2-4449.3l10.6 14.41 1.71-2.6-4.55-6.35-7.76-5.46z",
    transform: "matrix(1.37 1.4 -1.26 -1.4 359.75 -588.43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3820.2-4447l15.6 19.25-3.35-7.74-6.53-8.32-5.72-3.19z",
    transform: "matrix(.92 1.25 -.75 -1.2 896.99 -233.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3821-4448.7l12.21 17.13-.11-5.25-5.57-6.99-6.53-4.89z",
    transform: "matrix(.2 .85 .02 -.73 1547.59 307.23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3818.9-4446.9l1.97 4.26 4.24 2.13-1.8-3.38-4.41-3.01z",
    transform: "matrix(-1.14 -1.33 1 1.3 788.44 989.43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1v5.78l6.63 1.34-1.82-3.84-4.81-3.28z",
    transform: "matrix(-.5 -.73 .34 .64 325.56 337.13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1v5.78l6.63 1.34-1.82-3.84-4.81-3.28z",
    transform: "matrix(-.84 -.28 .9 .4 1501.16 974.27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1v5.78l6.63 1.34-1.82-3.84-4.81-3.28z",
    transform: "matrix(.7 .14 -.82 -.25 -238.04 -272.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l15.68 18.95-10.18-13.71-.69-1.96-4.81-3.28z",
    transform: "matrix(.25 .62 -.13 -.56 1093.02 160.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l10.95 13.18-4.32-6.06-1.82-3.84-4.81-3.28z",
    transform: "matrix(1.64 1.38 -1.6 -1.44 -104.7 -827.04)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l-14.43-12.59 18.26 16.79.98-.92-4.81-3.28z",
    transform: "matrix(1.46 .6 -1.6 -.77 -839.02 -829.37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1v5.78l6.63 1.34-1.82-3.84-4.81-3.28z",
    transform: "matrix(-.36 -.73 .22 .66 328.35 444.53)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M759.39 305.01c-3.24 1.066-4.827 1.573-6.465 1.782.835.357 2.69.14 4.807.71-1.886.042-5.374 1.48-6.825 1.516 1.003.602 4.58.022 5.238.18-1.913.118-4.99 1.6-6.908 1.6-.878.67 4.46-.46 6.602.807-2.216-.114-6.52 1.16-8.85.853 1.777 1.042 4.952-.112 7.6 1.017-.767.084-6.91.772-9.086.445 1.3.65 5.218.543 6.18 1.12-1.62-.21-5.927.69-7.425.332 1.348.972 5.413.424 6.16 1.01-2.657.925-6.683.186-8.535.437 1.242.58 2.267 1.167 3.366 1.71 1.605 1.127 6.61 4.294 9.6 5.245-3.31-.433-4.464-.49-6.603-.665l4.867 5.16c-2.03-1.095-5.61-3.162-7.988-4.23-5.264-2.577-9.058-2.13-12.704-4.313-5.122-4.966-7.966-10.885-8.222-12.464-.257-1.578-.48-4.407-5.153-2.933 4.51-.58 6.405-5.792 6.758-5.583.16.09.578 3.483 1.638 4.853.706.983 6.71 4.348 7.706 4.527 8.943-5.314 16.197-5.967 24.24-3.117z",
    transform: "matrix(1.05 0 0 1.4 -29.62 -119.66)",
    strokeWidth: 0.375,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 0.25,
    transform: "matrix(1.1 0 0 1.27 -358.42 -17.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(44.69)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -352.62,
    x: 802.37,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.02 334.335c-.21-1.173-.348-1.765.244-3.303.864-1.083 1.317-2.043 2.893-3.164 1.71-.563 2.286-.055 4.528-2.134.72-1.37 1.82-2.405 2.445-3.882 1.46-2.177 1.95-3.252 3.12-4.927 1.55-1.74 2.8-3.302 3.708-4.636.97-1.71 1.84-2.768 3.245-4.174.57-1.604 1.79-2.794 3.245-4.172 1.113-2.033 3.247-4.36 4.173-6.027 1.642-1.88 2.284-2.697 3.71-4.636 1.254-.827 3.37-2.643 5.1-3.244 2.358-.99 3.62-1.97 5.172-.464 1.027 1.027 2.873 2.68 1.59 3.9-.675.748-1.78.84-3.054.273-1.31-.848-1.946-3.315-3.71-1.39-1.273 1.454-1.926 2.615-3.708 4.17-.886 1.305-1.525 2.28-2.318 4.174-1.048 1.208-1.914 2.567-2.78 4.635-1.125.928-2.094 2.77-2.783 4.172-1.113 1.166-1.916 2.364-2.783 4.173-1.75 1.677-2.405 3.095-3.71 4.172-.86 1.82-2.216 3.558-3.244 4.636-.812 1.32-1.618 2.695-2.318 4.173-1.475 1.506-1.54 1.83-3.71 4.173-1.805 2.355-1.197 2.07-4.025 4.8-1.548.51-3.103.685-5.03-1.298z",
    fill: "#006000"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(22.17)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -20.84,
    x: 862.29,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(24.03)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -48.488,
    x: 863.44,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(35.85)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -224.52,
    x: 840.48,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(49.53)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -420.33,
    x: 773.6,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(45.46)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -363.86,
    x: 799.69,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(35.85)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -224.23,
    x: 844.16,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(35.85)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -224.62,
    x: 842.29,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(35.85 -1.43 -10.31)",
    fill: "#e4cc00"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.57,
    x: 838.79
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.68,
    x: 840.85
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.66,
    x: 843
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.7,
    x: 845.3
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.54,
    x: 847.15
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -245.75,
    x: 857.84
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -245.32,
    x: 856.37
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -245.1,
    x: 854.94
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -245.02,
    x: 852.83
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.68,
    x: 850.76
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.64,
    x: 848.96
  })), /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(28.47 -.2 -.77)",
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -115.05,
    x: 859.81,
    fill: "#e4cc00"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(35.85 -14.89 -15.59)",
    fill: "#e4cc00"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.57,
    x: 838.79
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.68,
    x: 840.85
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.66,
    x: 843
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.7,
    x: 845.3
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.54,
    x: 847.15
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -245.75,
    x: 857.84
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -245.32,
    x: 856.37
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -245.1,
    x: 854.94
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -245.02,
    x: 852.83
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.68,
    x: 850.76
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.391,
    ry: 5.563,
    height: 11.127,
    width: 2.782,
    y: -244.64,
    x: 848.96
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "matrix(1.06 0 0 1.15 -335.89 12.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(18.82)",
    rx: 1.432,
    ry: 0.678,
    height: 24.19,
    width: 2.864,
    y: -28.09,
    x: 774.89,
    strokeWidth: 0.172,
    fill: "#b2802e"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.432,
    ry: 0.678,
    height: 24.19,
    width: 2.864,
    y: 221.74,
    x: 727.44,
    strokeWidth: 0.172,
    fill: "#b2802e"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 1.432,
    ry: 0.678,
    height: 24.19,
    width: 2.864,
    y: 221.28,
    x: 707.97,
    strokeWidth: 0.172,
    fill: "#b2802e"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.25,
    fill: "#004500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-14.492-19.462 1.56-16.9 2.41.754-2.172 2.144-5.51 2.76-4.52.572-1.702 6.83 7.266 12.633 1.96 1.508 6.33 4.597 6.33 4.597s-1.583 2.788-1.734 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014.687 3.448.084 7.97-1.055 3.918-1.582 3.466-1.81-.075.785-2.466-2.345-6.312-2.344-8.272z",
    transform: "matrix(.42 .6 -.7 .23 583.24 -257.26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-6.197-19.173 9.854-16.61 2.41.753 1.945 1.61-1.392 2.227-4.52.57-14.114 7.073-5.146 12.875 1.96 1.508 6.33 4.597 6.33 4.597s-1.583 2.788-1.734 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014 1.095 5.817.492 10.34-1.055 3.917-1.582 3.465-1.81-.076.076-.602-2.753-8.68-2.752-10.64z",
    transform: "matrix(.38 .62 -.7 .2 612.9 -260.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-2.64-11.925 11.99-9.1 1.586.2-2.096 2.163-5.433 2.78-4.52.57-12.21-.99-3.24 4.813 1.958 1.508 6.328 4.597 6.328 4.597s-1.582 2.788-1.733 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014 7.07 9.44 6.467 13.96-1.055 3.92-1.582 3.467-1.81-.074.076-.603-8.728-12.303-8.727-14.263z",
    transform: "matrix(.33 .65 -.7 .13 652.31 -262.77)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.25,
    fill: "#004500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-10.194-16.4 5.857-13.838 2.41.753-2.095 2.164-5.432 2.78-4.52.572-6.077 3.75 2.89 9.55 1.96 1.51 6.33 4.598 6.33 4.598s-1.582 2.788-1.733 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014-1.734 3.165-2.337 7.687-1.055 3.918-1.582 3.466-1.81-.075.076-.604.076-6.03.077-7.99z",
    transform: "matrix(.43 .6 -.7 .24 560.19 -256.51)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-10.194-16.4 5.857-13.838 2.41.753-2.095 2.164-5.432 2.78-4.52.572-6.077 3.75 2.89 9.55 1.96 1.51 6.33 4.598 6.33 4.598s-1.582 2.788-1.733 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014-1.734 3.165-2.337 7.687-1.055 3.918-1.582 3.466-1.81-.075.076-.604.076-6.03.077-7.99z",
    transform: "matrix(.4 .62 -.7 .2 589.82 -260.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-10.194-16.4 5.857-13.838 2.41.753-2.095 2.164-5.432 2.78-4.52.572-6.077 3.75 2.89 9.55 1.96 1.51 6.33 4.598 6.33 4.598s-1.582 2.788-1.733 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014-1.734 3.165-2.337 7.687-1.055 3.918-1.582 3.466-1.81-.075.076-.604.076-6.03.077-7.99z",
    transform: "matrix(.34 .65 -.7 .14 629.21 -262.57)"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.25,
    fill: "#004500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-14.492-19.462 1.56-16.9 2.41.754-2.172 2.144-5.51 2.76-4.52.572-1.702 6.83 7.266 12.633 1.96 1.508 6.33 4.597 6.33 4.597s-1.583 2.788-1.734 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014.687 3.448.084 7.97-1.055 3.918-1.582 3.466-1.81-.075.785-2.466-2.345-6.312-2.344-8.272z",
    transform: "matrix(.2 .7 -.73 -.02 770.2 -279)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-6.197-19.173 9.854-16.61 2.41.753 1.945 1.61-1.392 2.227-4.52.57-14.114 7.073-5.146 12.875 1.96 1.508 6.33 4.597 6.33 4.597s-1.583 2.788-1.734 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014 1.095 5.817.492 10.34-1.055 3.917-1.582 3.465-1.81-.076.076-.602-2.753-8.68-2.752-10.64z",
    transform: "matrix(.15 .72 -.72 -.06 799.25 -272.13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.68 226.06c.3-4.898 4.144-6.405 10.4-4.22.527.302.98-.602.828-.678-10.023-5.274-2.64-11.925 11.99-9.1 1.586.2-2.096 2.163-5.433 2.78-4.52.57-12.21-.99-3.24 4.813 1.958 1.508 6.328 4.597 6.328 4.597s-1.582 2.788-1.733 2.788c-.15 0-12.207-4.37-15.07-.603-1.81 3.014 7.07 9.44 6.467 13.96-1.055 3.92-1.582 3.467-1.81-.074.076-.603-8.728-12.303-8.727-14.263z",
    transform: "matrix(.1 .73 -.72 -.12 837.06 -260.81)"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    transform: "matrix(1.1 0 0 1.27 -361.45 -17.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 1.432,
    ry: 0.678,
    height: 24.19,
    width: 2.864,
    y: 222.49,
    x: 826.05,
    strokeWidth: 0.172,
    fill: "#b2802e"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.333,
    fill: "#007500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l-7.42-2.76 15.13 11.39-2.9-5.35-4.81-3.28z",
    transform: "matrix(2.83 -1.24 -3.05 .95 -1925.62 -304.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l-5.31.27 12.7 7.59-2.58-4.58-4.81-3.28z",
    transform: "matrix(3.13 -.33 -3.22 -.02 -1573.42 -1098.14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.9-4447.6l4.64 7.4 4.42 1.26-3.58-4.96-5.48-3.7z",
    transform: "matrix(-2.35 -1.9 2.13 2.18 1324.03 2719.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3821.8-4448.7l17.53 22.4-6.67-12.48-3.47-5.09-7.39-4.83z",
    transform: "matrix(-3.1 -.45 3.1 .8 2735.85 2087.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3822.2-4449.9l-12.5-6.51 24.05 18.66-3.81-6.13-7.74-6.02z",
    transform: "matrix(2.85 1.2 -2.74 -1.54 -448.35 -2034.45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3823.5-4450.2l-5.23-1.22 17.81 13.32-3.56-5.79-9.02-6.31z",
    transform: "matrix(2.03 2.16 -1.77 -2.43 720.32 -2307.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3824.7-4451.7l-13.4-9.74 24.35 20.96-.74-3.33-10.21-7.89z",
    transform: "matrix(.34 2.82 .04 -2.9 2314.66 -1926.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3822.2-4449.3l10.6 14.41 1.71-2.6-4.55-6.35-7.76-5.46z",
    transform: "matrix(-1.55 2.47 1.92 -2.34 3429.12 -741.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3820.2-4447l15.6 19.25-3.35-7.74-6.53-8.32-5.72-3.19z",
    transform: "matrix(-2.4 1.85 2.68 -1.6 3638.7 109.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3821-4448.7l12.21 17.13-.11-5.25-5.57-6.99-6.53-4.89z",
    transform: "matrix(-3.04 .75 3.2 -.42 3422.62 1206.87)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3818.9-4446.9l1.97 4.26 4.24 2.13-1.8-3.38-4.41-3.01z",
    transform: "matrix(2.05 -2.16 -2.38 1.96 -1931.76 726.96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1v5.78l6.63 1.34-1.82-3.84-4.81-3.28z",
    transform: "matrix(1.5 -1.04 -1.62 .8 -633.93 -217.22)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1v5.78l6.63 1.34-1.82-3.84-4.81-3.28z",
    transform: "matrix(-1.52 -1.17 1.2 1.3 424.38 1558.92)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1v5.78l6.63 1.34-1.82-3.84-4.81-3.28z",
    transform: "matrix(1.7 .92 -1.6 -1.12 156.59 -1254.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l15.68 18.95-10.18-13.71-.69-1.96-4.81-3.28z",
    transform: "matrix(-1.85 .67 2 -.5 2589.49 580.62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l10.95 13.18-4.32-6.06-1.82-3.84-4.81-3.28z",
    transform: "matrix(-.6 2.78 1 -2.76 2955.04 -1435.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1l-14.43-12.59 18.26 16.79.98-.92-4.81-3.28z",
    transform: "matrix(2.13 2.1 -1.88 -2.36 604.09 -2303.24)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3819.3-4447.1v5.78l6.63 1.34-1.82-3.84-4.81-3.28z",
    transform: "matrix(1.96 -.88 -2.12 .67 -1083.67 -148.42)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj);
export default __webpack_public_path__ + "static/media/fj.60c9f64bcea6aa3d2129793b1ab40c14.svg";
export { ForwardRef as ReactComponent };